import { defineMessages } from "react-intl";

export default defineMessages({
    notifications: {
        id: "components.header.headerNotifications.notifications",
        defaultMessage: "Notifications",
    },
});
